/**
 * Groups flat repo arrays from the profile API into logical repositories.
 * Each logical repo groups repos sharing the same owner/name/orgId.
 */
export function groupReposIntoLogical(repos) {
  const groups = new Map();

  for (const repo of repos) {
    const orgId = repo.orgId ? String(repo.orgId) : "";
    const key = `${repo.owner}\0${repo.name}\0${orgId}`;
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key).push(repo);
  }

  const result = [];
  for (const members of groups.values()) {
    const canonical = pickCanonical(members);
    const branches = [];
    for (const repo of members) {
      const src = repo.analysisSource;
      const branch = src?.requestedBranch || src?.defaultBranch || null;
      if (branch) {
        branches.push({
          repoId: repo._id,
          branch,
          status: repo.status,
        });
      }
    }

    branches.sort((a, b) => {
      if (a.repoId === canonical._id) return -1;
      if (b.repoId === canonical._id) return 1;
      return (a.branch || "").localeCompare(b.branch || "");
    });

    result.push({
      canonicalRepo: canonical,
      allRepoIds: members.map((r) => r._id),
      branches,
      branchCount: branches.length,
    });
  }

  return result;
}

function pickCanonical(members) {
  const withoutBranch = members.filter(
    (r) => !r.analysisSource?.requestedBranch
  );
  if (withoutBranch.length > 0) {
    return withoutBranch.sort((a, b) => {
      if (a.status === "completed" && b.status !== "completed") return -1;
      if (b.status === "completed" && a.status !== "completed") return 1;
      return 0;
    })[0];
  }
  const defaultBranchRepos = members.filter((r) => {
    const src = r.analysisSource;
    return src?.requestedBranch && src.requestedBranch === src.defaultBranch;
  });
  if (defaultBranchRepos.length > 0) return defaultBranchRepos[0];
  return members.sort((a, b) => {
    const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
    const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
    return bTime - aTime;
  })[0];
}
